<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">{{
        "common.cancel" | translate
      }}</ion-button>
    </ion-buttons>

    @if (isNewEvent) {
    <ion-title>{{ "calendar.newEvent" | translate }}</ion-title>
    } @if (!isNewEvent) {
    <ion-title>{{ "calendar.editEvent" | translate }}</ion-title>
    }
    <ion-buttons slot="end">
      @if ( isNewEvent && this.selectedEvent.endDate >
      this.selectedEvent.startDate ) {
      <ion-button (click)="confirm()">{{
        "common.create" | translate
      }}</ion-button>
      } @if ( !isNewEvent && this.selectedEvent.endDate >
      this.selectedEvent.startDate ) {
      <ion-button (click)="confirm()">{{
        "common.update" | translate
      }}</ion-button>
      }
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <ion-list>
    <ion-item>
      <ion-input
        labelPlacement="floating"
        [(ngModel)]="selectedEvent.name"
        mode="md"
      >
        <div slot="label">{{ "common.name" | translate }}</div>
      </ion-input>
    </ion-item>
    <!--ion-item>
        <ion-toggle [(ngModel)]="fullDayEvent" (ionChange)="fullDayToggle()"
          >Ganztägig</ion-toggle
          >
        </ion-item-->
    <ion-item>
      <ion-label>{{ "common.start" | translate }}</ion-label>

      <lib-date-time-picker
        slot="end"
        [inputDateZulu]="isNewEvent ? null : this.selectedEvent.startDate"
        (selectedDateChanged)="newEventStartDateChanged($event)"
      ></lib-date-time-picker>
    </ion-item>
    <ion-item>
      <ion-label>{{ "common.end" | translate }}</ion-label>

      <lib-date-time-picker
        [hourDelay]="1"
        slot="end"
        [inputDateZulu]="isNewEvent ? null : this.selectedEvent.endDate"
        (selectedDateChanged)="newEventEndDateChanged($event)"
      ></lib-date-time-picker>
    </ion-item>
    @if (this.selectedEvent.endDate < this.selectedEvent.startDate) {
    <ion-item style="color: red">{{
      "calendar.endBeforeStart" | translate
    }}</ion-item>
    }
  </ion-list>

  <div class="container">
    <br />

    <ion-select
      [label]="'calendar.title' | translate"
      label-placement="floating"
      mode="md"
      fill="outline"
      [(ngModel)]="this.selectedEvent.calendarId"
      (ionChange)="evCalendarChange($event)"
    >
      @for (ev of this.availableCalendars; track ev) {
      <ion-select-option [value]="ev.id">{{ ev.name }}</ion-select-option>
      }
    </ion-select>

    <br />
    <ion-textarea
      [label]="'common.description' | translate"
      labelPlacement="floating"
      fill="outline"
      mode="md"
      [(ngModel)]="this.selectedEvent.description"
      [placeholder]="'common.addDescription' | translate"
    ></ion-textarea>
    <!--lib-user-picker
          *ngIf="isNewEvent"
          [users]="this.state.users$"
          [showAllEntry]="false"
          [multiple]="true"
          (selectedUserChanged)="selectedWorkerChange($event)"
        ></lib-user-picker-->
    <br />
    @if (!isNewEvent) {
    <ion-button style="width: 100%" color="danger" (click)="deleteEvent()">{{
      "calendar.deleteEvent" | translate
    }}</ion-button>
    }
  </div>
</ion-content>
